import CircularProgress from '@mui/material/CircularProgress/CircularProgress';
import { DetailedHTMLProps, HTMLAttributes, PropsWithChildren } from 'react';

const LoadingContainer = ({
    isLoading,
    children,
    ...props
}: PropsWithChildren<DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement> & { isLoading: boolean }>) =>
    isLoading ? (
        <div className="relative h-svh" {...props}>
            <CircularProgress className="absolute top-2/4 right-2/4" />
        </div>
    ) : (
        children
    );

export { LoadingContainer };
